module.exports = __webpack_public_path__ + "img/store-icon.ce0e1c9.svg";